import { sva } from '@portal/styled-system/css'

export const navbar = sva({
    className: 'navbar',
    slots: ['root', 'list'],
    base: {
        root: {
            height: 'var(--play-nav-height)',
            width: 'full',
            paddingInline: '3',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: 'gray.50',
            fontFamily: 'montserrat',
            fontSize: '[14px]',
            lineHeight: '[20px]',
        },
        list: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '0', // reset ul
            marginBottom: '0', // reset ul
            padding: '0', // reset ul
            listStyle: 'none', // reset ul
        },
    },
    variants: {
        isFixed: {
            true: {
                root: {
                    position: 'fixed',
                    top: '0',
                    right: '0',
                    left: '0',
                    zIndex: 1030,
                },
            },
        },
    },
})

export const navbarItem = sva({
    className: 'navbarItem',
    slots: ['content'],
    base: {
        content: {
            backgroundColor: 'transparent', // reset button
            borderInline: 'none', // reset button
            borderY: '[3px solid transparent]',
            paddingX: '2',
            paddingY: '[3px]',
            color: 'neutral.900',
            textTransform: 'uppercase',
            textDecoration: 'none',
            _hover: {
                color: 'neutral.700',
                borderBottomColor: 'primary',
            },
            _focus: {
                boxShadow: '[0 0 0 0.1rem var(--shadow-color)]',
                boxShadowColor: `[green/40]`,
                borderY: 'none',
                outline: 'none',
            },
        },
    },
})

export const navbarMenu = sva({
    className: 'navbarMenu',
    slots: ['separator', 'item', 'itemNav', 'icon', 'iconPrimary'],
    base: {
        separator: {
            backgroundColor: 'neutral.200',
            height: '[1px]',
            width: 'full',
            marginY: '2',
        },
        item: {
            display: 'block',
            width: 'full',
            textAlign: 'start',
            paddingX: '4',
            paddingY: '1',
            fontSize: '[14px]',
            lineHeight: 'none',
            color: 'neutral.600',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            _hover: {
                color: 'info',
                textDecoration: 'underline',
            },
            _focus: {
                outline: 'none',
                color: 'info',
                textDecoration: 'underline',
            },
        },
        itemNav: {
            display: 'flex',
            width: 'full',
            alignItems: 'center',
            paddingX: '4',
            height: '[28px]',
            color: 'neutral.800',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            textDecoration: 'none',
            _hover: {
                color: 'white',
                backgroundColor: 'info',
                '& .navbarMenu__icon': {
                    color: 'white',
                },
            },
            _focus: {
                outline: 'none',
                color: 'white',
                backgroundColor: 'info',
                '& .navbarMenu__icon': {
                    color: 'white',
                },
                '& .navbarMenu__iconPrimary': {
                    color: 'white',
                },
            },
        },
        icon: {
            width: '3',
            color: 'success',
        },
        iconPrimary: {
            color: 'primary',
        },
    },
})
